import { render, staticRenderFns } from "./qishi.vue?vue&type=template&id=5c330978&scoped=true&"
import script from "./qishi.vue?vue&type=script&lang=js&"
export * from "./qishi.vue?vue&type=script&lang=js&"
import style0 from "./qishi.vue?vue&type=style&index=0&id=5c330978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c330978",
  null
  
)

export default component.exports